import React, { useMemo } from 'react';
import { selectStato, selectTab, selectTipo } from 'features/carrello/carrelloSelectors';

import { MyBet } from 'components/myBet/MyBet';
import styles from './CarrelloScommesse.module.scss';
import { useSelector } from 'react-redux';
import { useTranslation } from 'hooks/useLingUI';

export type CarrelloScommesseProps = {};

export const CarrelloScommesse = ({}: CarrelloScommesseProps) => {
  const { t } = useTranslation();
  const tabScommessa = useSelector(selectTab);
  const tipoScommessa = useSelector(selectTipo);
  const statoScommessa = useSelector(selectStato);

  const labels = useMemo(
    () => ({
      cashOut: '',
      seeNext: t('load-next-cart', 'next page'),
    }),
    [t]
  );

  const objResult = useMemo(
    () => (
      <MyBet
        key={`cart-${tabScommessa}-${tipoScommessa}-${statoScommessa}`}
        labels={labels}
        canScroll
        isInColumn
        cashOutEnabled={false}
      />
    ),
    [labels, statoScommessa, tabScommessa, tipoScommessa]
  );

  return <div className={styles.container}>{objResult}</div>;
};